import { Calendar as CalendarIcon } from 'iconoir-react'
import { useMemo } from 'react'
import Combo from 'app/components/ui/combo/combo'
import type { ScorecardJson } from 'app/types/entities'
import { OptionType } from 'types/OptionType'

const getPeriodLabel = (dateRange: string, lookbackType: string, i: number) => {
  if (lookbackType === `year_over_year` || dateRange === `this_year` || dateRange === `last_year`) {
    return `${i.toString()} Year${i > 1 ? `s` : ``}`
  }
  if (dateRange === `today` || dateRange === `last_30_days` || dateRange === `last_90_days`) {
    return `${i.toString()} Day${i > 1 ? `s` : ``}`
  }
  if (dateRange === `this_week` || dateRange === `last_week`) {
    return `${i.toString()} Week${i > 1 ? `s` : ``}`
  }
  if (
    dateRange === `this_month` ||
    dateRange === `last_month` ||
    dateRange === `last_6_months` ||
    dateRange === `last_12_months`
  ) {
    return `${i.toString()} Month${i > 1 ? `s` : ``}`
  }
  if (dateRange === `this_quarter`) {
    return `${i.toString()} Quarter${i > 1 ? `s` : ``}`
  }
  return ``
}

export default function LookbackAmountSelector({
  currentValue,
  onChange,
  inputClassName,
  currentDateRange,
  currentLookbackType,
}: {
  currentValue: number
  onChange: (value: number) => void
  inputClassName?: string
  currentDateRange: NonNullable<ScorecardJson[`dateRange`]>
  currentLookbackType: string
}) {
  const selectorOptions = useMemo(() => {
    let max = 12
    if (currentDateRange === `today` || currentDateRange === `last_30_days` || currentDateRange === `last_90_days`) {
      max = 31
    }
    const options: OptionType[] = []
    for (let i = 1; i <= max; i++) {
      options.push({
        value: i,
        name: getPeriodLabel(currentDateRange, currentLookbackType, i),
        id: i.toString(),
      })
    }
    return options
  }, [currentDateRange, currentLookbackType])
  const value = useMemo(
    () => selectorOptions.find((option) => option.value === currentValue),
    [currentValue, selectorOptions],
  )
  return (
    <Combo
      showSearchInDropdown={false}
      options={selectorOptions}
      value={value}
      onChange={(option) => onChange(option.value)}
      customIcon={<CalendarIcon className="h-5 w-5 text-default" />}
      className="!h-fit w-40 cursor-pointer"
      optionsContainerClassName="min-w-0 w-64"
      inputClassName={inputClassName}
    />
  )
}
